import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { actions, useSelector } from '../store';
import { selectCall, selectEndpoint, selectLine } from '../store/reducers/janus';
import css from './WebRtcClient.module.scss';
import Audio from './Audio';
import ConnectScreen from './ConnectScreen';
import Phone from './Phone';
import Ringer from './Ringer';
import { LogOutIcon } from './icons';
import { registerWebRtcGlobals } from './RegisterWebRtcGlobals';
import classNames from 'classnames';
import { Settings } from '../model';

export type WebRtcClientProps = {
  className?: string
  enabled: boolean
  extension?: string
  pin?: string
  settings: Settings
}

export default function WebRtcClient(props: React.PropsWithChildren<WebRtcClientProps>) {
  const endpoint = useSelector(selectEndpoint)
  const line = useSelector(selectLine)
  const call = useSelector(selectCall)
  const initialisedRef = useRef(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (endpoint.status === 'offline' && !initialisedRef.current) {
      dispatch(actions.initApp())
      if (window.citrixVdaSupport === true) {
        console.info('Citrix Vda Support, overriding WebRTC implementation')
        registerWebRtcGlobals()
      }
      initialisedRef.current = true
    }
  }, [dispatch, endpoint.status])

  useEffect(() => {
    dispatch(actions.configureEndpoint(props.settings))
  }, [dispatch, props.settings])

  useEffect(() => {
    if (!props.enabled && endpoint.canDisconnect) {
      console.log('Softphone is being disabled, disconnecting...')
      dispatch(actions.disconnectEndpoint())
    }
  }, [dispatch, endpoint.canDisconnect, props.enabled])

  return <div className={classNames(css.app, props.className)}>
    {renderApp()}
  </div>

  function renderApp() {
    if (endpoint.status !== 'online' || endpoint.statusError || line.statusError || line.status === 'registering' || line.status === 'unregistered') {
      return <ConnectScreen enabled={props.enabled} extension={props.extension} pin={props.pin} />
    }

    return <>
      <Phone />
      <Audio />
      <Ringer />
      <div className={css.logout}>
        {!call.canHangUp && endpoint.canDisconnect && <button onClick={() => dispatch(actions.disconnectEndpoint())}><LogOutIcon /></button>}
      </div>
      <div className={css.headset}>
        {endpoint.canDisconnect && <button onClick={() => dispatch(actions.pairHeadset())}><LogOutIcon /></button>}
      </div>
      {props.children}
    </>
  }
}
